export default {
  computed: {
    isAsesor() {
      const groups = (this.$isObject(this.groups) && Object.keys(this.groups)) || [];
      return this.fungsi === 'kasek' ? groups.includes('147') : groups.includes('148');
    },

    configs() {
      const start = new Date(this.tglBuka).getDate();
      const finish = new Date(this.tglTutup).getDate();
      const diff = finish - start;
      return {
        tgl_mulai: this.tglBuka.split(' ')[0],
        tgl_selesai: this.tglTutup.split(' ')[0],
        bulan: this.$localDate(this.tglTutup).split(' ')[1],
        title: `${this.fLabel} dan Wawancara`,
        total: diff + 1,
        slot: this.masterConfigSlot,
        min: this.configSlot?.min_slot ?? 0,
        max: this.configSlot?.max_slot ?? 0,
        catatan:
          '*) Catatan : Silahkan set tanggal susulan 28 september, kemudian pilih slot minimal 2 dan klik terapkan baru simpan tombol kanan atas.',
        blokir_slot: this.$getDeepObj(this, 'configSlot.blokir_slot') || {},
        is_asesor_bantu: this.isAsesor && this.configSlot && Number(this.configSlot.is_penjadwal) === 0,
        url_meet: this.$getDeepObj(this, 'configSlot.url_meet') || '',
      };
    },

    isSusulan() {
      return new Date(this.wktOnline) > new Date('2020-09-12 23:59:00');
    },

    tabItem() {
      let temp = [];
      temp.push({ value: 0, text: 'Jadwal Reguler' });
      temp.push({ value: 1, text: 'Susulan 13 September' });
      temp.push({ value: 2, text: 'Susulan 28 September' });

      return temp;
    },

    labels() {
      return {
        guru: {
          tgl_nilai: {
            1: '21 - 23 September 2020',
            2: '05 - 25 Januari 2021',
          },
          wkt_selesai: {
            1: '23 Sep 2020 pkl. 23.59',
          },
        },
        mentor: {},
      };
    },

    blokirs() {
      return [];
    },
  },
  methods: {
    filterPenilaian(item) {
      const isUtama = this.$getDeepObj(item, 'psp_simulasi.penilai_id') === this.akunId;
      const penilaian = this.$getDeepObj(item, 'gpm_penilaians') || [];

      let obj = { is_lengkap: 0 };
      let result = {};

      if (this.isAsesor) {
        result = penilaian.find((key) => Number(key.k_penilaian_gpm) === (isUtama ? 6 : 7)) || {};
        return result;
      } else {
        if (!penilaian.length || penilaian.length === 1) return obj;
        this.$set(obj, 'is_lengkap', penilaian.find((key) => key.is_lengkap === 0) ? 0 : 1);
        return obj;
      }
    },

    async onNilai(item, form) {
      let params = {
        k_profil_psp: this.kProfil,
        gelombang: this.params.gelombang,
      };

      const kategori = {
        simulasi: null,
        wawancara: null,
      };

      if (
        Number(item.k_proses_simulasi_psp) === 6 &&
        this.$getDeepObj(item, 'psp_profil_nilais.data.0.nilai') &&
        this.$getDeepObj(item, 'psp_profil_nilais.data.1.nilai')
      ) {
        kategori.simulasi = this.kategoris[Number(this.$getDeepObj(item, 'psp_profil_nilais.data.0.nilai'))];
        kategori.wawancara = this.kategoris[Number(this.$getDeepObj(item, 'psp_profil_nilais.data.1.nilai'))];
      }

      const { data, meta } = await this.getDetail({ id: item.psp_profil_id, api: this.api, params });
      let { akun_penjadwal, akun_pendamping, akun_penilai } = this.$getDeepObj(data, 'psp_simulasis.data.0') || {};
      let pspSimulasi = this.$getDeepObj(data, 'psp_simulasis.data.0') || {};

      if (this.isUtama(item)) {
        const isKonfirmasi = data && data.k_proses_simulasi_psp === 6;
        if (isKonfirmasi) {
          const status = await this.$confirm(
            'Asesor B sudah konfirmasi penilaian, apakah anda yakin ingin mengubah nilai ?',
            'Konfirmasi'
          );
          if (!status) {
            return;
          }
        }
      }

      this.$set(this, 'formulir', {});
      this.$set(this.formulir, 'form', form);
      this.$set(this.formulir, 'title', form === 'FormWawancara' ? `Penjadwalan ${this.fLabel}` : 'Penilaian Kandidat');
      this.$set(this.formulir, 'id', this.$getDeepObj(item, 'psp_simulasi_id'));
      this.$set(this.formulir, 'autoClose', false);
      this.$set(this.formulir, 'isPreview', !this.isAsesor);
      this.$set(this.formulir, 'init', null);
      const init = Object.assign({}, data, {
        psp_simulasi: Object.assign({}, pspSimulasi, {
          akun_penilai: akun_penilai,
          akun_penjadwal: akun_penjadwal,
          akun_pendamping:
            akun_penjadwal?.data?.akun_id === akun_penilai?.data?.akun_id ? akun_pendamping : akun_penjadwal,
        }),
        google_suit: Object.assign({}, this.gSuite, meta),
        kategori: kategori,
      });

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$refs.formulir.resetTab();
        this.$set(this.formulir, 'init', init);
        if (!this.isMulaiWawancara(pspSimulasi)) {
          this.$set(this.formulir.init, 'durasi', this.getDurasi(pspSimulasi) || '');
        }
      });
    },

    async onDetil(data) {
      this.$set(this, 'dialog', true);
      this.$set(this, 'detail', data || {});

      this.$nextTick(() => {
        this.$refs.infokandidat.reset();
      });
    },

    async onEdit() {
      const resp = await this.getSlot({
        tipe: !this.isAsesorA || this.isTutup ? 'slot-gabungan' : 'slot',
        api: this.api,
        params: this.deffProfil,
      });
      let result = [];
      this.$set(this, 'formulir', {});
      this.$set(this.formulir, 'form', 'FormWawancara');
      this.$set(this.formulir, 'autoClose', true);
      this.$set(this.formulir, 'isPreview', !this.isAsesorA || this.isTutup);
      this.$set(this.formulir, 'title', 'Atur Jadwal Anda');
      this.$set(this.formulir, 'id', null);

      let init = {};
      for (
        let d = new Date(this.configs.tgl_mulai);
        d <= new Date(this.configs.tgl_selesai);
        d.setDate(d.getDate() + 1)
      ) {
        const date = this.$localDate(this.$dateToString(new Date(d)));
        let sesi = [];

        let filters = resp.filter((s) => this.$localDate(s.tgl_simulasi) === date) || [];
        if (filters.length) {
          filters.forEach((key) => {
            sesi.push(key.slot.toString());
          });
          result.push({ tgl_wawancara: this.$dateToString(new Date(d)).split(' ')[0], sesi: sesi });
        }
      }

      if (result.length) {
        init = result;
      }

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', init);
      });
    },

    async onSave() {
      let keys = {
        kasek: {
          simulasi: ['71', '72', '73', '74', '75', '76'],
          wawancara: ['81', '82', '83', '84', '85', '86', '87', '88', '89', '90'],
        },
        instruktur: {
          simulasi: ['271', '272', '273', '274', '275', '276'],
          wawancara: ['281', '282', '283', '284', '285', '286', '287', '288'],
        },
      };

      // let exclude = ['catatan', 'kendala', 'url_recording', 'is_kendala', 'is_kepsek'];
      // let is_rekomendasi_susulan = false;

      const type = this.formulir.form === 'FormPenilaianMicroteaching' ? 'nilai' : 'update';
      const formulir = this.$refs.formulir.getValue();
      const form = formulir.form;
      // const formatDate = ['jam_mulai', 'jam_selesai'];

      if (type === 'update') {
        this.onUpdateSlot(form);
        return;
      }

      // let kosong = false;
      let query = {};
      let params = {};

      let simulasi = {};

      if (formulir.isAsesorUtama) {
        if ([2, 3].includes(formulir.sesi)) {
          if (!formulir.simulasi.kendala) {
            this.$error('Harap mengisikan catatan kendala');
            this.$refs.modal.loading = false;
            return;
          }
          simulasi = Object.assign(
            {},
            {
              kendala_penilai: formulir.simulasi.kendala,
              is_ulang: formulir.simulasi.is_ulang,
            }
          );

          params = Object.assign({}, { simulasi });
        } else if (Number(formulir.sesi) === 1) {
          simulasi = Object.assign(
            {},
            {
              catatan_penilai: formulir.simulasi.catatan,
              url_rekaman: formulir.simulasi.url_rekaman || '',
            }
          );

          let isLengkap = {
            simulasi: false,
            wawancara: false,
          };
          const nilais = { ...formulir };

          Object.keys(keys[this.fungsi]).forEach((key) => {
            let lengkap = true;
            keys[this.fungsi][key].forEach((item) => {
              const exclude = {
                wawancara: [undefined, '', '0'],
                simulasi: [undefined, ''],
              };
              if (exclude[key].includes(nilais[`nilai_${key}`][item])) {
                lengkap = false;
              }
            });
            isLengkap[key] = lengkap;
          });

          if (!isLengkap.simulasi) {
            this.$error(`Harap melengkapi rubrik ${this.fLabel} yang ditentukan`);
            this.$refs.modal.loading = false;
            return;
          } else if (!isLengkap.wawancara) {
            this.$error(`Harap melengkapi rubrik wawancara yang ditentukan`);
            this.$refs.modal.loading = false;
            return;
          }

          params = Object.assign(
            {},
            {
              simulasi: simulasi,
              nilai_simulasi: formulir.nilai_simulasi,
              nilai_wawancara: formulir.nilai_wawancara,
            }
          );
        } else {
          this.$error('Harap memilih status penilaian');
          this.$refs.modal.loading = false;
          return;
        }
      } else {
        if (!formulir.simulasi.is_setuju_nilai) {
          this.$error('Harap konfirmasi hasil penilaian Asesor A terlebih dahulu');
          this.$refs.modal.loading = false;
          return;
        }

        simulasi = {
          is_setuju_nilai: 1,
          catatan_pendamping: formulir.simulasi.catatan,
        };
        params = Object.assign({}, { simulasi });
      }

      this.update({
        method: 'post',
        id: this.formulir.id,
        api: this.api,
        params: params,
        name: 'nilai',
        query: query,
      })
        .then(() => {
          this.$success([2, 3].includes(formulir.sesi) ? 'Kendala Berhasil disimpan' : 'Nilai Berhasil disimpan');
          this.onReload();
          this.fetchStatistik();
          this.$refs.modal.dialog = false;
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onActions(item) {
      this.onNilai(item, 'FormPenilaianMicroteaching');
    },

    allow(action, data) {
      return this.$allow(action.akses, data.policies);
    },

    onUpdateSlot(data = []) {
      let total = 0;
      let filters = data.filter((s) => s.useDelete === true);
      let isBlokirJumat = false;

      if (!filters.length) {
        this.$error('Harap tentukan jadwal dengan valid');
        this.$refs.modal.loading = false;
        return;
      }

      //Validasi tambahan untuk blokir hari jumat
      if (filters) {
        filters.forEach((key) => {
          const day = new Date(key.tgl_wawancara).getDay();
          const sesi = key.sesi_wawancara || [];
          if (day === 5) {
            sesi.forEach((s) => {
              if ([...this.blokirs].includes(Number(s))) {
                isBlokirJumat = true;
              }
            });
          }
        });
      }

      if (isBlokirJumat) {
        this.$error('Sesi 3 dan 4 pada hari jumat tidak boleh dipilih');
        this.$refs.modal.loading = false;
        return;
      }

      if (filters) {
        filters.forEach((key) => {
          total += key.sesi_wawancara.length;
        });
      }

      if (total < this.configs.min) {
        this.$error('Jadwal yang anda pilih kurang dari ketentuan');
        this.$refs.modal.loading = false;
        return;
      } else if (total > this.configs.max) {
        this.$error('Jadwal yang anda pilih melebihi ketentuan');
        this.$refs.modal.loading = false;
        return;
      }

      let params = [];

      filters.forEach((key) => {
        params.push({ tgl_simulasi: key.tgl_wawancara, slot: key.sesi_wawancara });
      });

      this.updateSlot({ params: { data: params, k_profil_psp: this.kProfil, gelombang: 1 }, api: this.api })
        .then(() => {
          this.$success(
            'Pengaturan jadwal Simulasi dan Wawancara telah berhasil, silahkan menunggu penjadwalan bersama asesor lainnya'
          );
          this.$refs.modal.dialog = false;
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    isTerkendala(item) {
      return !!item.kendala_penilai;
    },

    isUtama(item) {
      return this.$getDeepObj(item, 'penilai_id') === this.akunId;
    },

    onReschedule(data) {
      this.$confirm(
        `Anda yakin ingin reschedule jadwal kandidat <b>${this.$getDeepObj(data, 'gpm_guru.ptk.nama')}</b> ini ?`,
        'Reschedule Jadwal',
        {
          tipe: 'warning',
        }
      ).then(() => {
        this.reschedule({ id: data.gpm_guru_fungsi_id, params: { is_kendala: 1 } }).then(() => {
          this.$success('Reschedule berhasil di lakukan, kandidat akan dijadwalkan ulang');
          this.onReload();
        });
      });
    },

    onBatalReschedule() {
      this.$confirm('Anda yakin ingin batalkan reschedule jadwal kandidat ini ?', 'Batal Reschedule', {
        tipe: 'error',
      }).then(() => {});
    },

    getPasangan(item) {
      const pspSimulasi = this.$getDeepObj(item, 'psp_simulasis.data.0') || {};
      let asesor = [];
      let keys = ['akun_penjadwal', 'akun_pendamping'];
      keys.forEach((key) => {
        if (this.$getDeepObj(pspSimulasi, key)) {
          asesor.push(this.$getDeepObj(pspSimulasi, key));
        }
      });

      let find = asesor.findIndex((s) => s.data.akun_id === this.akunId);
      if (find > -1) {
        asesor.splice(find, 1);
      }

      return asesor[0]['data'] || {};
    },

    getKategoriNilai(item) {
      const penilaians = (item && item.gpm_penilaians) || [];
      const asesor1 = penilaians.find((s) => Number(s.k_penilaian_gpm) === 6) || {};
      const asesor2 = penilaians.find((s) => Number(s.k_penilaian_gpm) === 7) || {};

      return {
        asesor1: asesor1,
        asesor2: asesor2,
      };
    },

    onClose() {
      if (!this.formulir['autoClose'] && this.isAsesor) {
        const msg = [
          `<h3>Apakah Anda yakin ingin keluar dari halaman Penilaian ${this.fLabel} ?</h3>`,
          'data yang tidak disimpan akan hilang jika Anda keluar dari Halaman ini',
        ].join(' ');
        this.$confirm(msg, 'Peringatan', { tipe: 'error', lblConfirmColor: 'red', lblCancelColor: 'grey' }).then(() => {
          this.$refs.modal.dialog = false;
        });
      } else {
        this.$set(this.formulir, 'init', null);
        this.$set(this.formulir, 'init', null);
        this.$refs.modal.dialog = false;
      }
    },

    toLink(tipe) {
      switch (tipe) {
        case 'sop-penilaian':
          window.open('https://drive.google.com/file/d/16WCJFPOMrNIfVxVsZ9CFSrA7qQNmTF_D/view?usp=sharing', '_blank');
          break;
      }
    },
  },
};
